import React, { FC, useState } from 'react';
import {
  Edit,
  EditProps,
  FormTab,
  ListButton,
  TabbedForm,
  useDataProvider,
  useEditController,
  useNotify,
  useRedirect,
  useRefresh,
} from 'react-admin';
import { getDrawDate } from '../../helpers/getDrawDateFromCompetitions';
import { makeUpWinnersRequest } from '../../helpers/winnerRequest';
import { WinnerCreateData, WinnerData } from '../../types/winnerRequest';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import StaffUserFormToolbar from '../staff/StaffUserFormToolBar';
import RenderEditComponent from './render-edit-component';
import { Box, Button } from '@material-ui/core';
import { Widget } from '../../types/widget';
// import DescriptionTabForm from "./DescriptionTabForm";

const EditWidget: FC<EditProps> = (props) => {
  const controllerProps = useEditController<any>(props);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = (widgetId: string) => async (data) => {
    const result = await dataProvider.updateWidget(widgetId, {
      ...data,
    });

    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Winner successfully update`);
    redirect('/widgets');
  };

  const onSubmit = (widgetId: string) => async (data: Widget) => {
    if (controllerProps.record) {
      const widgetData = {
        active: controllerProps.record.active,
        type: controllerProps.record.type,
        name: controllerProps.record.name,
        ...data,
      };

      const result = await dataProvider.updateWidget(widgetId, widgetData);

      if (!result || !result.data) {
        notify('something went wrong', 'error');
        return;
      }
      notify(`Widget successfully update`);
      redirect('/widgets');
    }
  };
  const onCancel = () => {
    redirect('/widgets');
  };
  const validateWinner = (value) => {
    const errors: any = {};

    if (!value.name) {
      errors.name = ['Title is required'];
    }
    if (!value.photoUrl && !value.videoUrl) {
      errors.photoUrl = [
        'Please choose photo or upload a photo. At least something should be chosen',
      ];
      errors.videoUrl = [
        'Please choose video url or upload a photo. At least something should be chosen',
      ];
    }
    return errors;
  };
  return (
    <>
      <DocumentTitle
        core='Widgets'
        purpose={`${controllerProps.record?.name}`}
        appointment=''
      />

      <Edit {...props}>
        {controllerProps.record && (
          <TabbedForm
            toolbar={
              <></>
              //   <StaffUserFormToolbar
              //     onSuccess={onSuccess(controllerProps.record.id)}
              //     {...props}
              //   />
            }
            // validate={validateWinner}
          >
            <FormTab label='Description'>
              <RenderEditComponent
                widget={controllerProps.record}
                widgetType={controllerProps.record.type}
                widgetData={controllerProps.record.data}
                onSubmit={onSubmit(controllerProps.record._id)}
                onCancel={onCancel}
              />
            </FormTab>
          </TabbedForm>
        )}
      </Edit>
    </>
  );
};
export default EditWidget;
